import React from 'react';
import ReactDOM from 'react-dom/client';
import { analytics } from '@heycatch/sdk';
// Theme tokens first: every other stylesheet resolves var(--…) against these.
import './styles/theme.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { HelmetProvider } from 'react-helmet-async';

/**
 * HeyCatch analytics.
 *
 * Deliberately at module scope, above the render, with a static import and no
 * `typeof window` guard or once-flag — their install guide requires all of
 * that, and a guard is the documented way this ends up silently not
 * initialising. The project key is a PUBLISHABLE key (hck_pk_…), so inlining it
 * is correct rather than sloppy; it is not a secret.
 *
 * tracingHosts is set because the app talks to api.shakespeareai.net, a
 * different origin from the one serving this bundle. apiHost is omitted per the
 * guide, and requestBatching is left at its default because this is a real SPA
 * rather than a multi-page app doing full page loads. The static blog under
 * /blog is separate HTML and does not load this bundle at all.
 *
 * KNOWN GAP, flagged to the owner on install: this fires regardless of the
 * cookie banner. components/CookieConsent.tsx's disableTracking() opts out of
 * GA4 and Google Ads when someone clicks Decline; HeyCatch is not covered by
 * it, because the guide forbids the guard that would do so. Gating init behind
 * consent is a small change if the compliance position changes.
 */
analytics.init({
  projectKey: 'hck_pk_mM4cH9qYXbdWTi63igA_mhSMLl9C4eDv',
  tracingHosts: ['api.shakespeareai.net'],
  install: {
    framework: 'react',
    frameworkVersion: '19',
    agent: 'claude-code',
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
